import * as _actions from './actions';
import _reducer from './reducer';
import AttendanceHistory from './model';
import * as _accessors from './accessors';

export default AttendanceHistory;

export const actions = _actions;
export const reducer = _reducer;
export const accessors = _accessors;



// WEBPACK FOOTER //
// ./data/AttendanceHistory/index.js